// services/sentry.js
import * as Sentry from '@sentry/vue'
import { generateUuidFromEmail } from '../helpers/trackingUtils'

/**
 * Sets the cart configuration context in Sentry.
 *
 * @param {Object} cartConfig - The cart configuration object to set as context.
 */
export function setCartConfigContext(cartConfig) {
    try {
        Sentry.setContext('cartConfig', cartConfig)
        console.log('Sentry cartConfig context set successfully.')
    } catch (error) {
        console.error('Failed to set cartConfig context in Sentry:', error)
    }
}

/**
 * Safely captures an error in Sentry with additional context.
 * @param {Error} error - The error to capture
 * @param {Object} [context] - Additional context to add to the error
 */
export function captureError(error, context = {}) {
    try {
        Sentry.captureException(error, {
            extra: context
        })
    } catch (e) {
        console.error('Failed to capture error in Sentry:', e)
    }
}

/**
 * Sets user context in Sentry
 * @param {Object} user - User information
 */
export function setUserContext(user) {
    try {
        if (user?.email) {
            Sentry.setUser({
                email: user.email,
                id: generateUuidFromEmail(user.email),
                ...user
            })
        }
    } catch (error) {
        console.error('Failed to set user context in Sentry:', error)
    }
}
